import script from "./select2-wrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./select2-wrapper.vue?vue&type=script&setup=true&lang=js"

import "select2/dist/css/select2.css?vue&type=style&index=0&lang=css&external"

const __exports__ = script;

export default __exports__